import React from 'react';
const DashboardHome =()=>{
    return (
        <div>
            <h1> this is Dashboard </h1>
        </div>
    )
}

export default DashboardHome;